var _DFloatBody;
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import Component from "@glimmer/component";
import { concat, hash } from "@ember/helper";
import { htmlSafe } from "@ember/template";
import { modifier as modifierFn } from "ember-modifier";
import concatClass from "discourse/helpers/concat-class";
import closeOnClickOutside from "discourse/modifiers/close-on-click-outside";
import TrapTab from "discourse/modifiers/trap-tab";
import DFloatPortal from "float-kit/components/d-float-portal";
import { getScrollParent } from "float-kit/lib/get-scroll-parent";
import FloatKitApplyFloatingUi from "float-kit/modifiers/apply-floating-ui";
import FloatKitCloseOnEscape from "float-kit/modifiers/close-on-escape";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
export default class DFloatBody extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "closeOnScroll", modifierFn(() => {
      const firstScrollParent1 = getScrollParent(this.trigger);
      const handler1 = () => {
        this.args.instance.close();
      };
      firstScrollParent1.addEventListener("scroll", handler1, {
        passive: true
      });
      return () => {
        firstScrollParent1.removeEventListener("scroll", handler1);
      };
    }));
  }
  get supportsCloseOnClickOutside() {
    return this.args.instance.expanded && this.options.closeOnClickOutside;
  }
  get supportsCloseOnEscape() {
    return this.args.instance.expanded && this.options.closeOnEscape;
  }
  get supportsCloseOnScroll() {
    return this.args.instance.expanded && this.options.closeOnScroll;
  }
  get trigger() {
    return this.args.instance?.trigger;
  }
  get content() {
    return this.args.instance?.content;
  }
  get options() {
    return this.args.instance.options;
  }
}
_DFloatBody = DFloatBody;
setComponentTemplate(createTemplateFactory(
/*
  
    <DFloatPortal
      @inline={{@inline}}
      @portalOutletElement={{@instance.portalOutletElement}}
    >
      <div
        class={{concatClass
          @mainClass
          (if this.options.animated "-animated")
          (if @instance.expanded "-expanded")
        }}
        data-identifier={{this.options.identifier}}
        data-content
        aria-labelledby={{@instance.id}}
        aria-expanded={{if @instance.expanded "true" "false"}}
        role={{@role}}
        {{FloatKitApplyFloatingUi this.trigger this.options @instance}}
        {{(if @trapTab (modifier TrapTab autofocus=this.options.autofocus))}}
        {{(if
          this.supportsCloseOnClickOutside
          (modifier
            closeOnClickOutside @instance.close (hash target=this.content)
          )
        )}}
        {{(if
          this.supportsCloseOnEscape
          (modifier FloatKitCloseOnEscape @instance.close)
        )}}
        {{(if this.supportsCloseOnScroll (modifier this.closeOnScroll))}}
        style={{htmlSafe (concat "max-width: " this.options.maxWidth "px")}}
        ...attributes
      >
        <div class={{@innerClass}}>
          {{yield}}
        </div>
      </div>
    </DFloatPortal>
  
*/
{
  "id": "tXPE0zJT",
  "block": "[[[1,\"\\n    \"],[8,[32,0],null,[[\"@inline\",\"@portalOutletElement\"],[[30,1],[30,2,[\"portalOutletElement\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[11,0],[16,0,[28,[32,1],[[30,3],[52,[30,0,[\"options\",\"animated\"]],\"-animated\"],[52,[30,2,[\"expanded\"]],\"-expanded\"]],null]],[16,\"data-identifier\",[30,0,[\"options\",\"identifier\"]]],[24,\"data-content\",\"\"],[16,\"aria-labelledby\",[30,2,[\"id\"]]],[16,\"aria-expanded\",[52,[30,2,[\"expanded\"]],\"true\",\"false\"]],[16,\"role\",[30,4]],[16,5,[28,[32,2],[[28,[32,3],[\"max-width: \",[30,0,[\"options\",\"maxWidth\"]],\"px\"],null]],null]],[17,5],[4,[32,4],[[30,0,[\"trigger\"]],[30,0,[\"options\"]],[30,2]],null],[4,[52,[30,6],[50,[32,5],2,null,[[\"autofocus\"],[[30,0,[\"options\",\"autofocus\"]]]]]],null,null],[4,[52,[30,0,[\"supportsCloseOnClickOutside\"]],[50,[32,6],2,[[30,2,[\"close\"]],[28,[32,7],null,[[\"target\"],[[30,0,[\"content\"]]]]]],null]],null,null],[4,[52,[30,0,[\"supportsCloseOnEscape\"]],[50,[32,8],2,[[30,2,[\"close\"]]],null]],null,null],[4,[52,[30,0,[\"supportsCloseOnScroll\"]],[50,[30,0,[\"closeOnScroll\"]],2,null,null]],null,null],[12],[1,\"\\n        \"],[10,0],[15,0,[30,7]],[12],[1,\"\\n          \"],[18,8,null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[\"@inline\",\"@instance\",\"@mainClass\",\"@role\",\"&attrs\",\"@trapTab\",\"@innerClass\",\"&default\"],false,[\"if\",\"modifier\",\"yield\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/float-kit.d0433c99/node_modules/float-kit/components/d-float-body.js",
  "scope": () => [DFloatPortal, concatClass, htmlSafe, concat, FloatKitApplyFloatingUi, TrapTab, closeOnClickOutside, hash, FloatKitCloseOnEscape],
  "isStrictMode": true
}), _DFloatBody);